import React from 'react';
import PropTypes from 'prop-types';
import {observable, action} from 'mobx';
import {inject, observer} from 'mobx-react';

import {cn} from 'spa/css';
import {mobxPromise} from 'utils/mobx';

import {withI18n} from 'spa/Components/Context';
import {browserOnly} from 'spa/Components/EnvSplit';
import ProgressButton from 'spa/Components/ProgressButton';
import autobind from 'autobind-decorator';

import CitySelectPopup from 'spa/Components/CitySelectPopup';

@browserOnly
@inject(({store: {session, tracker}}) => ({session, tracker}))
@observer
@withI18n
class LoginWithFacebook extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    discountId: PropTypes.string,
    isSignup: PropTypes.bool,
    label: PropTypes.string,
    onLoginSuccess: PropTypes.func,
    session: PropTypes.shape({
      isLoadingFacebook: PropTypes.bool.isRequired,
      isLoggedIn: PropTypes.bool,
      initFacebook: PropTypes.func.isRequired,
      facebookLogin: PropTypes.func.isRequired,
    }).isRequired,
    signupCampaign_id: PropTypes.string,
    signupId: PropTypes.string,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
  };

  static contextTypes = {
    cityId: PropTypes.string,
  };

  static defaultProps = {
    isSignup: false,
  }

  UNSAFE_componentWillMount() {
    this.openCityPopup = false;
    this.selectedCity = '';
    this.observable = mobxPromise(this.props.session.initFacebook());
  }

  @observable openCityPopup;

  @observable selectedCity;

  @action onSelectCity = (city, acceptedMarketingOptInAt = null) => {
    this.selectedCity = city.id;
    this.openCityPopup = false;
    this.connectToFacebook(this.selectedCity, acceptedMarketingOptInAt);
  }

  @action onCloseCityPopup = (event) => {
    if (event) {
      event.preventDefault();
    }

    this.openCityPopup = false;
  }

  @autobind onClick(event) {
    event.preventDefault();
    if (!this.observable.fulfilled) {
      return;
    }

    if (this.context.cityId) {
      this.selectedCity = this.context.cityId;
      this.connectToFacebook(this.selectedCity);
    } else {
      this.openCityPopup = true;
    }
  }

  @action connectToFacebook = (selectedCityId, acceptedMarketingOptInAt) => {
    const {
      discountId, onLoginSuccess, signupId, signupCampaign_id,
    } = this.props;

    const loginData = {
      cityId: selectedCityId,
    };

    if (signupId) {
      loginData.signupId = signupId;
    }

    if (discountId) {
      loginData.discountScheme_id = discountId;
    }

    if (signupCampaign_id) {
      loginData.signupCampaign_id = signupCampaign_id;
    }

    if (acceptedMarketingOptInAt) {
      loginData.acceptedMarketingOptInAt = acceptedMarketingOptInAt;
    }

    this.props.session.facebookLogin(loginData)
      .then((response) => {
        if (response.isNewUser) {
          this.props.tracker.track('Created Account', {
            source: 'facebook',
          });
        }

        this.props.tracker.track('Facebook Login', {
          category: this.props.trackingCategory,
          label: response.user.id,
        });
        if (onLoginSuccess) {
          onLoginSuccess();
        }
      }, (error) => {
        if (error.code === 'FACEBOOK_LOGIN_MISSING_EMAIL') {
        // missing email address
          this.props.tracker.track('Facebook Login missing info', {
            category: this.props.trackingCategory,
            label: error.profile && error.profile.id,
          });
        } else {
          this.props.tracker.track('Facebook Login Failed', {
            category: this.props.trackingCategory,
            label: `${error}`,
          });
        }
      });
  }

  render() {
    const {i18n} = this.context;
    const {
      isSignup,
      session,
      disabled,
      className,
      label = i18n.__('Login with facebook'),
      ...rest
    } = this.props;
    const {isLoadingFacebook, isLoggedIn} = session;
    return (
      <div>
        {this.openCityPopup && (
          <CitySelectPopup
            isSignup={isSignup}
            onClick={this.onSelectCity}
            onClose={this.onCloseCityPopup}
          />
        )}
        <ProgressButton
          {...rest}
          tag="a"
          href="#"
          theme="facebook"
          label={label}
          block
          onClick={this.onClick}
          disabled={!this.observable.fulfilled || isLoadingFacebook || disabled}
          loading={isLoadingFacebook}
          done={isLoggedIn}
          className={cn('js-only', className)}
          data-testid="login-with-facebook-button"
        />
      </div>
    );
  }
}

export default LoginWithFacebook;



// WEBPACK FOOTER //
// ./spa/Components/Session/LoginWithFacebook.jsx